// core
import { Component, Inject, OnInit, ViewChild, QueryList, ElementRef, Renderer2, ViewChildren, AfterViewInit, AfterContentInit, ViewEncapsulation } from '@angular/core';
import { matDialog } from '@campfire-nx/material';

@Component({
  selector: 'animated-transition-interstitial',
  templateUrl: './animated-transition-interstitial.component.html',
  styleUrls: ['./animated-transition-interstitial.component.scss']
})
export class AnimatedTransitionInterstitialComponent implements AfterViewInit {
  defaultTotalDuration: number = 6;
  maxContentSteps = 4;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    @Inject(matDialog.MAT_DIALOG_DATA) public data: any
  ) {}

  ngAfterViewInit() {
    if (this.data && this.data.content && this.data.content.length) {
      // We only support maximum 4 steps for this interstitial type
      this.data.content.splice(this.maxContentSteps);

      this.applyAnimation();
    }
  }

  applyAnimation() {
    const animationDuration = ((this.data.time/1000) || this.defaultTotalDuration) / this.data.content.length;

    this.data.content.forEach((item: any, index: number) => {
      const delay = animationDuration * index;
      let textBlockAnimationName;
      switch(index) {
        case 0:
          // First animation mat-card
          textBlockAnimationName = 'dissapear';
          break;
        case this.data.content.length - 1:
          // Last animation mat-card
          textBlockAnimationName = 'appear';
          break;
        default:
          // All animation mat-card between first and last
          textBlockAnimationName = 'appearDissapear';
          break;
      }

      // Create a <style> element
      const style = this.renderer.createElement('style');

      // The keyframes used in animation classes of this style, are defined in open theme
      // This is done because the style gets added to head i.e. global scope.
      //  So keyframes must be defined globally
      style.textContent = `
        .animate-mat-card-${index} {
          animation: expandContract ${animationDuration}s 1;
          animation-delay: ${delay}s;

          svg {
            g.animate {
              &:not(.fill) {
                path, rect, circle, line {
                  animation: iconColorSwitchAndRestore ${animationDuration}s 1;
                  animation-delay: ${delay}s;
                  stroke: var(--theme-brand-icon, map.get($open-colors, "core-brand-icon"));
                }
              }
              &:not(.stroke) {
                path, rect, circle, line {
                  animation: iconColorSwitchAndRestore ${animationDuration}s 1;
                  animation-delay: ${delay}s;
                  fill: 'red';
                }
              }
            }
          }
        }

        .animate-progress-bar {
          animation: linearProgressIncrement ${(this.data.time/1000) || this.defaultTotalDuration}s forwards;
        }

        .animate-text-block-${index} {
          animation: ${textBlockAnimationName} ${animationDuration}s forwards;
          animation-delay: ${delay}s;
        }
      `;
      // Append the style to the head
      this.renderer.appendChild(document.head, style);

      // Find the target elements
      const iconCard = this.el.nativeElement.querySelector(`.icon-card.card-${index}`);
      const progressBar = this.el.nativeElement.querySelector('.progress-bar');
      const textBlock = this.el.nativeElement.querySelector(`.text-block.block-${index}`);

      // Add the dynamically created class to the elements
      this.renderer.addClass(iconCard, `animate-mat-card-${index}`);
      this.renderer.addClass(progressBar, 'animate-progress-bar');
      this.renderer.addClass(textBlock, `animate-text-block-${index}`);

      // If steps are equal or more than max add class to fit icon cards on mobile
      if (this.data.content.length >= this.maxContentSteps) {
        this.renderer.addClass(iconCard, 'max-steps');
      }

      // When the text-block dissapears it needs to be removed to make place for next next-block
      // Safari is unable to apply 'display:none' during animation, so applying that from script
      // Wait for the animation to complete, then apply display: none
      textBlock.addEventListener('animationend', () => {
        this.renderer.setStyle(textBlock, 'display', 'none');
      }, { once: true });
    });
  }
}
